<template>
  <div id="contact">
  <div class="form" :class="[$mq, {TA: isTestAchat}]">
    <h1>{{ $t("step4.title") }}</h1>

    <Providers v-if="!simulation && solarPanelsScenario !== 'COMM_OFFTAKE_AND_INJECTION'"/>

    <div
      v-if="errorMessage"
      class="modal-container"
      :class="$mq"
      @click="close()"
    >
      <div class="modal" :class="$mq">
        <div class="close" @click="close()">x</div>
        {{ $t("step3.error-consumption") }}
      </div>
    </div>

    <div v-if="error" class="modal-container" :class="$mq" @click="close()">
      <div class="modal" :class="$mq">
        <div class="close" @click="close()">x</div>
        {{ $t("step3.error") }}
        <a @click="getData()">{{ $t("step3.error-choice1") }}</a>
        {{ $t("step3.error-choice2") }}
      </div>
    </div>

    <div class="section" v-if="((!isBxl || allowBXResi) && (!$store.state.common.is2Step || !restrictedPostalCodes.includes($store.state.calculation.zipCode))) && !isProDisabled" :class="$mq">
      <div class="title">{{ $t("step4.segment.title") }}</div>
      <SwitchField id="isPro" name="isPro" v-model="isPro" :options="[$t(`step4.segment.b2b`), $t(`step4.segment.b2c`)]" :default="isPro" />
    </div>
    <div v-if="!isTestAchat" class="section" :class="$mq">
      <div class="title">{{ $t("step4.contact.title") }}</div>
      <ValidationObserver ref="observer" v-slot="{ valid }" slim>
        <div class="container inline h-item-margin">
          <label for="civility">
            <h4>{{ $t("step4.contact.civility") }}</h4>
            <ValidationProvider
              :rules="{required: agentJwt || hasStartedFilling}"
              v-slot="{ errors }"
            >
              <div :class="{error: errors.length}">
            <select
              id="civility"
              name="civility"
              v-model="civility"
              class="input"
              :disabled="!civilities.length"
            >
              <option
                v-for="item in civilities"
                :key="item"
                :data-selected="civility === item">{{ item }}</option>
            </select>
              <span class="input-error" v-if="errors.length">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </label>
      </div>
        <div class="container inline top">
          <label for="firstName">
            <h4>{{ $t("step4.contact.firstName") }}</h4>
            <ValidationProvider :rules="{required: agentJwt || hasStartedFilling, alpha: true, min:2, max:64}" v-slot="{ errors }">
              <div :class="{error: errors.length}">
                <input
                  type="text"
                  id="firstName"
                  v-model="firstName"
                  name="firstName"
                  class="input"
                />
                <span class="input-error" v-if="errors.length">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </label>
          <label for="lastName">
            <h4>{{ $t("step4.contact.lastName") }}</h4>
            <ValidationProvider :rules="{required: agentJwt || hasStartedFilling, alpha: true, min:2, max:64}" v-slot="{ errors }">
              <div :class="{error: errors.length}">
                <input
                  type="text"
                  id="lastName"
                  v-model="lastName"
                  name="lastName"
                  class="input"
                />
                <span class="input-error" v-if="errors.length">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </label>
        </div>

        <div class="container inline top">
          <label for="phone">
            <h4>{{ $t("step4.contact.phone") }}</h4>
            <ValidationProvider
              :rules="{required: agentJwt || (hasStartedFilling && (!mail || mail.length === 0)), international_phone: true}"
              v-slot="{ errors }"
              :customMessages="{ required: $t('step4.contact.required')}"
            >
              <div :class="{error: errors.length}">
                <input
                  type="text"
                  id="phone"
                  v-model="phone"
                  name="phone"
                  class="input"
                />
                <span class="input-error" v-if="errors.length">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </label>
          <label for="mail">
            <h4>{{ $t("step4.contact.mail") }}</h4>
            <ValidationProvider
              :rules="{required: agentJwt || (hasStartedFilling && (!phone || phone.length === 0)), email: true, noemail: true, specialchars: true }"
              v-slot="{ errors }"
              :customMessages="{ required: $t('step4.contact.required')}">
              <div :class="{error: errors.length}">
                <input
                  type="text"
                  id="mail"
                  v-model="mail"
                  name="mail"
                  class="input"
                />
                <span class="input-error" v-if="errors.length">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </label>
        </div>
      </ValidationObserver>
    </div>

    <div v-if="!isTestAchat" class="section" :class="$mq">
      <div class="container inline center h-item-margin margin" @click="() => {consent = consent ? 0 : 1}">
        <div class="check-button" :class="{active: consent, TA:isTestAchat}"></div>
        <div class="txt-left small grow">{{ $t(`step4.consent.text`) }}</div>
      </div>
    </div>

    <div class="error" v-if="error">{{ $t(`step4.${error}`) }}</div>

  </div>
  <div class="buttons inline space-between" :class="$mq">
    <PreviousButton @click="previousStep()" />
    <NextButton @click="getResult()" :label="$t('validate')" />
  </div>
  </div>
</template>

<script>
import CheckButton from "../components/Form/CheckButton.vue";
import SwitchField from "../components/Form/SwitchField.vue";
import NextButton from "../components/NextButton.vue";
import PreviousButton from "../components/PreviousButton.vue";
import Providers from "./calculation/Providers";
import { mapGetters, mapState } from "vuex";
import leadService from "../services/leadService";
export default {
  data() {
    return {
      error: null,
      errorMessage: null,
      agentRegex: new RegExp(/^AG[0-9]{6}$/)
    };
  },
  computed: {
    ...mapState("calculation", ["simulation", "area", "city"]),
    ...mapGetters("calculation", ["isBxl"]),
    ...mapGetters("common", ["isTestAchat", "allowBXResi", "restrictedPostalCodes"]),
    ...mapState("common", ["agentJwt", "agentRef"]),
    ...mapState("contact", ["civilities"]),
    ...mapState("energy", ["type"]),
    ...mapState("consumption", ["consumptions", "meterType", "solarPanelsScenario"]),
    ...mapState("comparison", ["elecProducts", "gasProducts"]),
    civility: {
      get() {
        return this.$store.state.contact.civility;
      },
      set(value) {
        this.$store.commit("contact/setCivility", value);
      }
    },
    firstName: {
      get() {
        return this.$store.state.contact.firstName;
      },
      set(value) {
        if(!!this.$store.state.contact.firstName && (this.$store.state.contact.firstName !== value)) {
          this.$store.commit("contact/setContactIsChanged", true);
        }
        this.$store.commit("contact/setFirstName", value);
      }
    },
    lastName: {
      get() {
        return this.$store.state.contact.lastName;
      },
      set(value) {
        if(!!this.$store.state.contact.lastName && (this.$store.state.contact.lastName !== value)) {
          this.$store.commit("contact/setContactIsChanged", true);
        }
        this.$store.commit("contact/setLastName", value);
      }
    },
    phone: {
      get() {
        return this.$store.state.contact.phone;
      },
      set(value) {
        if(!!this.$store.state.contact.phone && (this.$store.state.contact.phone !== value)) {
          this.$store.commit("contact/setContactIsChanged", true);
        }
        this.$store.commit("contact/setPhone", value);
      }
    },
    mail: {
      get() {
        return this.$store.state.contact.mail;
      },
      set(value) {
        if(!!this.$store.state.contact.mail && (this.$store.state.contact.mail !== value)) {
          this.$store.commit("contact/setContactIsChanged", true);
        }
        this.$store.commit("contact/setMail", value);
      }
    },
    isPro: {
      get() {
        return this.$store.state.contact.isPro;
      },
      set(value) {
        this.$store.commit("contact/setIsPro", value);
      }
    },
    consent: {
      get() {
        return this.$store.state.contact.consent;
      },
      set(value) {
        this.$store.commit("contact/setConsent", value);
      }
    },
    simulation: {
      get() {
        return this.$store.state.calculation.simulation;
      },
      set(value) {
        this.errorMessage = false;
        this.$store.commit("calculation/setSimulation", value);
      },
    },
    campaign() {
      return this.$route.query.campaign || this.$store.state.common.campaign;
    },
    isProDisabled() {
      switch(this.agentRef) {
        case 'AG000045':
          //return true
        default: return false
      }
    },
    isAgent() {
      return this.agentRef && this.agentRegex.test(this.agentRef);
    },
    hasStartedFilling() {
      return Boolean(
        this.consent
        || (this.firstName && this.firstName.length > 0)
        || (this.lastName && this.lastName.length > 0)
        || (this.phone && this.phone.length > 0)
        || (this.mail && this.mail.length > 0)
      );
    }
  },
  methods: {
    isExceedingConsumption() {
      this.errorMessage = false;
      let values = [];
      // We just handle the consumption that matches the selected meter type
      this.meterType.forEach((meterType) =>
        values.push(
          this.consumptions.find(
            (consumption) => consumption.meterType === meterType
          )
        )
      );
      // Retrieve the gas from all the values and parse it as an integer
      let gas = values.find((consumption) => consumption.meterType === "gas");
      let elec = 0;
      // Retrieve all the values execpt the gas because we already handled it
      values = values.filter((consumption) => consumption.meterType !== "gas");
      values.forEach((electricity) => {
        elec += parseInt(electricity.value);
      });

      if (this.simulation) {
        if (gas !== undefined) {
          if (gas.value >= 400000) {
            this.errorMessage = true;
          }
        }
        if (elec >= 200000) {
          this.errorMessage = true;
        }
      } else {
        if (gas !== undefined) {
          if (gas.value > 100000) {
            this.errorMessage = true;
          }
        }
        if (elec > 100000) {
          this.errorMessage = true;
        }
      }
    },
    async agentUpdateProspect() {
      if (
        this.$store.state.contact.contactFormFilledOnce &&
        this.$store.state.contact.contactIsChanged &&
        (this.$store.state.common.agent || this.$store.state.common.agentRef)
      ) {
        try {
          let response = await leadService.new();
          this.$store.commit("common/setUuid", response.uuid);
          await this.$store.dispatch("calculation/save");
          await this.$store.dispatch("consumption/save");
          await this.$store.dispatch("energy/save");
        } catch (error) {
          throw error;
        }
      }
    },
    previousStep() {
      this.$router.push({ name: "Consumption", query: this.$route.query });
    },
    async getResult() {
      this.isExceedingConsumption();
      await this.agentUpdateProspect();
      this.$store.commit("contact/setContactFormFilledOnce", true);
      if (
        (!this.isTestAchat && (await this.$refs.observer.validate()) && !this.errorMessage) || this.isTestAchat
      ) {
        if (this.simulation) {
          this.$store.commit("calculation/setProviderElec", null);
          this.$store.commit("calculation/setProviderGas", null);
        }
        this.$router.push({ name: "Process", query: this.$route.query });
      }
    },
  },
  created() {
    if (this.solarPanelsScenario === 'COMM_OFFTAKE_AND_INJECTION' && !this.simulation) {
      this.simulation = true;
    }

    if (!this.civilities.length) {
      this.$store.dispatch("contact/getCivilities", this.$i18n.locale);
    }

    if(this.isTestAchat) this.simulation = true;

    this.$store.commit("contact/setConsent", 0);
    this.$store.commit("contact/setContactIsChanged", false);

    window.scrollTo(0, 0);
  },
  components: { Providers, SwitchField, PreviousButton, NextButton, CheckButton }
};
</script>

<style lang="scss" scoped>
.city {
  margin: auto 10%;
  .grow {
    min-width: 250px;
    max-width: 400px;
    .input {
      width: 100%;
    }
  }
}

.check-button {
  width: 20px;
  height: 20px;
  border: 2px solid #888;

  &.radio {
    border-radius: 50%;
  }

  &.active {
    border: 2px solid #fdcb47;
    background: #fdcb47;
    position: relative;

    &::before {
      content: "";
      left: 0.4em;
      top: 0.1em;
      position: absolute;
      border-color: #fff;
      border-style: solid;
      border-width: 0 0.1em 0.1em 0;
      height: 0.8em;
      transform: rotate(45deg);
      width: 0.3em;
    }
  }

  &.TA {
    &.active {
      border: 2px solid $pink;
      background: $pink;
    }
  }
}

.small {
  font-size: 0.8rem;
}

.input-error {
  max-width: 250px;
  display: block;
  line-break: auto;
}

.comparaison--disabled {
  color: #00000038;
  cursor: not-allowed;
}

.error {
  margin-top: 10px;
  color: #f58b1e;
  display: block;
}

  #civility {
    min-width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue